module.exports = __webpack_public_path__ + "static/img/8.730f62d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/eng/8.png
// module id = qgKu
// module chunks = 0